import React from "react";
import { Box, Typography, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/styles";
import StarRating from "../StarRating/StarRating";

const useStyles = (theme, isMobile, mr, mb) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    minWidth: "251px",
    mr: { md: mr },
    mb: { xs: mb, md: 0 },
  },
  child: { display: "flex" },
  img: { height: "59.6px", width: "78.3px" },
  ratingContainer: { ml: "8.7px" },
  mainText: {
    fontFamily: theme.typography.montserrat.semibold,
    fontSize: "14px",
  },
  secondaryText: {
    fontFamily: theme.typography.montserrat.regular,
    fontSize: "12px",
  },
  span: {
    fontWeight: "bold",
    color: isMobile ? theme.palette.white.main : theme.palette.green.secondary,
  },
});

const CodingPlatformRatings = ({ img, mainText, ranking, mb, mr }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery("(max-width:899px)");
  const classes = useStyles(theme, isMobile, mr, mb);

  return (
    <Box sx={classes.container}>
      <Box sx={classes.child}>
        <img src={img} alt={`${mainText}`} style={classes.img} />
        <Box sx={classes.ratingContainer}>
          <StarRating />

          <Typography sx={classes.mainText}>{mainText}</Typography>
          <Typography sx={classes.secondaryText}>
            Ranking promedio <span style={classes.span}>{ranking}</span>
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default CodingPlatformRatings;
